import { FC } from 'react';
import Icon from './Icon';
import { IconSize, Icons, Weights } from '../enums';
import styled from 'styled-components';
import tw from 'twin.macro';

const ChipButton = styled.button<{ $hasValue: boolean }>`
  ${tw`relative flex items-center px-2 gap-1 border border-white min-h-7 bg-white/90 backdrop-blur rounded-full transition duration-200 ease-in-out flex p-0.5`};

  svg {
    ${tw`m-0`};

    ${({ $hasValue }) => ($hasValue ? tw`text-primary` : tw`text-slate-400`)};
  }

  &:active {
    ${tw`outline outline-slate-800/20 outline-offset-2`};
  }

  &:focus {
    ${tw`outline-primary`};
  }

  &:hover {
    ${tw`bg-white`};
  }
`;

const RefValue = styled.span`
  ${tw`text-xs text-primary`};
`;

const WeightContainer = styled.span`
  ${tw`text-sm relative flex items-center justify-center`};
`;

const WeightBgIcon = styled(Icon)`
  ${tw`absolute opacity-30`};
`;

interface Props {
  icon: Icons;
  hasValue: boolean;
  weightValue?: Weights;
  refValue?: number;
}

const Chip: FC<Props> = ({ hasValue, icon, weightValue, refValue }) => {
  const getWeightIcon = (weight?: Weights) => {
    if (weight === Weights.low)
      return <Icon icon={Icons.weightOne} size={IconSize.medium} />;
    if (weight === Weights.high)
      return <Icon icon={Icons.weightThree} size={IconSize.medium} />;
    return <Icon icon={Icons.weightTwo} size={IconSize.medium} />;
  };

  return (
    <ChipButton $hasValue={hasValue}>
      <Icon icon={icon} size={IconSize.medium} />
      {refValue !== 0 && <RefValue>{refValue}</RefValue>}
      {hasValue && (
        <WeightContainer>
          <WeightBgIcon icon={Icons.weightThree} size={IconSize.medium} />
          {getWeightIcon(weightValue)}
        </WeightContainer>
      )}
      <Icon icon={Icons.chevronUp} size={IconSize.small} />
    </ChipButton>
  );
};

export default Chip;
